import { Guid } from '@fitscovery/common/types';
import { BankDetails } from '../models';

export namespace BankActions {

  export class GetBanks {
    static readonly type = '[Bank] GetBanks';
    constructor() { }
  }

  export class GetBankDetailsByPartnerId {
    static readonly type = '[Bank] GetBankDetailsByPartnerId';
    constructor(public partnerId: Guid) { }
  }
  
  export class CreateBankDetails {
    static readonly type = '[Bank] CreateBankDetails';
    constructor(public bank: BankDetails) { }
  }
  
  export class UpdateBankDetails {
    static readonly type = '[Bank] UpdateBankDetails';
    constructor(public bank: BankDetails) { }
  }

}
